<script setup lang="ts">
import { userStickers } from "@/stores/stickers";
import { storeToRefs } from "pinia";

const stickerStore = userStickers();
const { createCollectionReqestParams } = storeToRefs(stickerStore);
const setSwedishName = (name: string) => {
  stickerStore.populateCreateCollectionRequest(name, "swedish_name");
};
const setEnglishName = (name: string) => {
  stickerStore.populateCreateCollectionRequest(name, "english_name");
};

const getError = (language: string) => {
  if (stickerStore.createCollectionProgress.step2) {
    if (
      language === "swedish" &&
      createCollectionReqestParams.value.svName === ""
    ) {
      return "Swedish name is required";
    } else if (
      language === "english" &&
      createCollectionReqestParams.value.enName === ""
    ) {
      return "English name is required";
    }
  }
};
</script>

<template>
  <section>
    <div class="name-desc">
      <h3 class="pn-m">Name collection</h3>
      <p class="pn-s width-67">
        Create a catchy name for the collection - one in Swedish and one an
        English. These names will be visible in the app/web tool and should
        preferably give the user an idea of what the stickers in the collection
        look like/can be used for.
      </p>
      <div class="sticker-list">
        <div
          class="sticker-item"
          v-for="sticker in createCollectionReqestParams.stickers"
          :key="sticker.filename"
        >
          <img
            class="thumb"
            :src="`data:image/svg+xml;base64,${sticker.base64}`"
            :alt="sticker.filename"
          />
        </div>
      </div>
      <div class="flex gap-32 name-inputs">
        <pn-input
          label="Swedish"
          helpertext="Type a catchy and descriptive name, e.g. “Kalasdjur” or “Det är kärlek i luften”."
          @input="setSwedishName($event.target.value)"
          :value="createCollectionReqestParams.svName"
          :error="getError('swedish')"
        ></pn-input>
        <pn-input
          label="English"
          helpertext="Type a catchy and descriptive name, e.g. “Party animals” or “Love is in the air”."
          @input="setEnglishName($event.target.value)"
          :value="createCollectionReqestParams.enName"
          :error="getError('english')"
        ></pn-input>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.name-desc {
  display: flex;
  flex-direction: column;
  padding-left: 32px;
}
.width-67 {
  width: 67%;
}
.gap-32 {
  gap: 32px;
}
.sticker-list {
  display: grid;
  grid-template-columns: repeat(13, 1fr);
  gap: 10px;
  padding: 8px 0;
}
.sticker-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  height: 60px;
}
.thumb {
  width: 100%;
  height: 60px;
  object-fit: contain;
}
.name-inputs {
  pn-input {
    flex: 1;
    min-width: 0;
  }
}
</style>
